<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="vm.workflowResult === workflowResults.successful">
  </ng-container>
</ng-container>
